import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import authService from '../services/authService';
import { LayoutDashboard, Home, Settings, LogOut, Users } from 'lucide-react';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authService.logout();
      toast.success('Logged out successfully');
      navigate('/admin-login');
    } catch (error) {
      toast.error('Logout failed');
    }
  };

  const navItems = [
    {
      label: 'Dashboard',
      path: '/',
      icon: LayoutDashboard,
    },
    {
      label: 'Properties',
      path: '/properties',
      icon: Home,
    },
    {
      label: 'Customers',
      path: '/customers',
      icon: Users,
    },
    {
      label: 'Settings',
      path: '/settings',
      icon: Settings,
    },
  ];

  return (
    <div className="relative h-screen w-20 sm:w-20 md:w-64 bg-white border-r border-gray-300 flex flex-col transition-all duration-300">
      {/* Logo */}
      <div className="p-4 sm:p-4 md:p-6 border-b border-gray-300 flex items-center justify-center sm:justify-center md:justify-start flex-col md:flex-row gap-3">
        <img 
          src="/images/Fade no bg.png" 
          alt="Project Prose Logo" 
          className="h-12 w-12 sm:h-12 sm:w-12 md:h-16 md:w-auto object-contain"
        />
        <div className="hidden md:block">
          <h1 className="text-2xl font-display font-bold text-prose-brand">Project Prose</h1>
          <p className="text-xs text-prose-brand/60 mt-1">Admin Dashboard</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 sm:px-2 md:px-4 py-6 space-y-2 flex flex-col items-center sm:items-center md:items-start">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              title={item.label}
              className={({ isActive }) =>
                `flex items-center space-x-3 w-full px-2 sm:px-2 md:px-4 py-3 rounded-lg transition duration-200 justify-center sm:justify-center md:justify-start ${
                  isActive
                    ? 'bg-prose-gold/20 text-prose-brand font-semibold'
                    : 'text-prose-brand/70 hover:bg-gray-100'
                }`
              }
            >
              <Icon size={20} />
              <span className="hidden md:inline">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-2 sm:p-2 md:p-4 border-t border-gray-300">
        <button
          onClick={handleLogout}
          title="Logout"
          className="w-full flex items-center justify-center sm:justify-center md:justify-start space-x-2 px-2 sm:px-2 md:px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white transition duration-200"
        >
          <LogOut size={18} />
          <span className="hidden md:inline">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
